const HideEyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
  <g clipPath="url(#clip0_28_13172)">
    <path d="M6.58657 6.58663C6.39007 6.76973 6.23246 6.99053 6.12315 7.23586C6.01384 7.48119 5.95506 7.74603 5.95032 8.01457C5.94559 8.28311 5.99498 8.54985 6.09557 8.79889C6.19616 9.04792 6.34588 9.27415 6.5358 9.46406C6.72572 9.65398 6.95194 9.8037 7.20097 9.90429C7.45001 10.0049 7.71675 10.0543 7.98529 10.0495C8.25383 10.0448 8.51867 9.98602 8.764 9.87671C9.00933 9.7674 9.23014 9.60979 9.41323 9.4133M7.1533 3.38671C7.43417 3.35171 7.71692 3.3339 7.99997 3.33337C12.6666 3.33337 14.6666 8.00004 14.6666 8.00004C14.3686 8.63812 13.9948 9.238 13.5533 9.78671M4.40665 4.40678C3.08081 5.30986 2.01989 6.55028 1.33331 8.00011C1.33331 8.00011 3.33331 12.6668 7.99998 12.6668C9.27725 12.6702 10.5272 12.2969 11.5933 11.5934M1.33331 1.33337L14.6666 14.6667" stroke="#3E5066" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_28_13172">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
);

export default HideEyeIcon;
